import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { globalErrorState, globalMessageState } from 'states/CommonStates/atoms';

export const useGlobalAlerts = () => {
  const [, setError] = useRecoilState(globalErrorState);
  const [, setMessage] = useRecoilState(globalMessageState);

  const showGlobalMessage = useCallback(
    (text: string, hideMessage: boolean = true, targetPath?: string) =>
      setMessage({
        isVisible: true,
        text,
        hideMessage,
        // wasShown: false,
        targetPath: targetPath || null,
      }),
    [setMessage]
  );

  const showGlobalError = useCallback(
    (text: string, hideMessage: boolean = true, targetPath?: string) =>
      setError({
        isVisible: true,
        text,
        hideMessage,
        // wasShown: false,
        targetPath: targetPath || null,
      }),
    [setError]
  );

  return {
    showGlobalError,

    showGlobalMessage,

    hideGlobalError: () =>
      setError({
        isVisible: false,
        text: '',
        hideMessage: true,
        // wasShown: false,
        targetPath: null,
      }),

    hideGlobalMessage: () =>
      setMessage({
        isVisible: false,
        text: '',
        hideMessage: true,
        // wasShown: false,
        targetPath: null,
      }),
  };
};